import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchVacation = (vacationId, childId) =>
    RESTClient.getAuthenticatedObservable('daycare/vacation/show2', {vacationId, childId});

export const updateReplyForChild = (vacationId, childId, days) =>
    RESTClient.postAuthenticatedObservable('daycare/vacation/updatereplyforchild', {
        vacationId,
        childId,
        days,
    });
